import { createContext } from 'react';
import { RtcOutput } from '../util/output/rtc';

export const RtcOutputContext = createContext<{output?: RtcOutput}>({});